import React from "react";
import { getMessage, changeLanguage } from "CONFIG/i18n";
import { supportedLanguages, DEFAULT_LANGUAGE } from "UTILS/Constants";
import { Row } from "react-bootstrap";
import { FormGroup, Input, Label } from "reactstrap";
import "./ChangeLanguage.less";
import moment from 'moment'
import 'moment/locale/ja';

function ChangeLanguage(props) {
  const onSelectChange = event => {
    changeLanguage(event.target.value);
    props.onSelectChange(event.target.value);

    let selectedLanguage = event.target.value;
    document.getElementById("lang-id").setAttribute("content", selectedLanguage);
    document.documentElement.setAttribute('lang', selectedLanguage);
    moment.locale(selectedLanguage);
  };

  return (
    <div>
      <Row className="noMargin">
        {Object.keys(supportedLanguages).map(lang => (
          <FormGroup check key={lang}>
            <Label check className="cursorPointer">
              <Input
                className="cursorPointer"
                type="radio"
                name="radio1"
                value={lang}
                onChange={onSelectChange}
                checked={
                  props.language ? props.language === lang : lang === DEFAULT_LANGUAGE
                }
              />{" "}
              {supportedLanguages[lang]}
            </Label>
          </FormGroup>
        ))}
        <a href={window._env_.HELP_URL} target='_blank'>{getMessage("ONLINE_HELP")}</a>
      </Row>
    </div>
  );
}
export default ChangeLanguage;
